export enum DOMAINS_MANAGEMENT {
    /**
     * @value Certificate successfully deployed
     */
    CERTIFICATE_DEPLOYED = 'DOMAINS_MANAGEMENT.CERTIFICATE_DEPLOYED',
    /**
     * @value Deploying certificate
     */
    CERTIFICATE_DEPLOYING = 'DOMAINS_MANAGEMENT.CERTIFICATE_DEPLOYING',
    /**
     * @value Step 1: Certificate deployment %DEPLOYMENT_STATUS%
     * @description The title of the domain management step 1
     */
    CERTIFICATE_DEPLOYMENT_TITLE = 'DOMAINS_MANAGEMENT.CERTIFICATE_DEPLOYMENT_TITLE',
    /**
     * @value Step 1: Certificate generation
     */
    CERTIFICATE_GENERATION_TITLE = 'DOMAINS_MANAGEMENT.CERTIFICATE_GENERATION_TITLE',
    /**
     * @value Deploying custom certificate
     */
    CUSTOM_CERTIFICATE_DEPLOYING = 'DOMAINS_MANAGEMENT.CUSTOM_CERTIFICATE_DEPLOYING',
    /**
     * @value Step 2: Domain configuration
     */
    DOMAIN_CONFIGURATION_TITLE = 'DOMAINS_MANAGEMENT.DOMAIN_CONFIGURATION_TITLE',
    /**
     * @value %DOMAIN_NAME% is ready to deploy
     * @description Information message for the status of the domain (migration ready)
     */
    DOMAIN_MIGRATED_READY = 'DOMAINS_MANAGEMENT.DOMAIN_MIGRATED_READY',
    /**
     * @value %DOMAIN_NAME% has been successfully deployed
     * @description Information message for the status of the domain (migration success)
     */
    DOMAIN_MIGRATED_SUCCESS = 'DOMAINS_MANAGEMENT.DOMAIN_MIGRATED_SUCCESS',
    /**
     * @value You don’t have any vanity URL
     */
    NO_VANITY_URL = 'DOMAINS_MANAGEMENT.NO_VANITY_URL',
    /**
     * @value Pending completion of Step 1
     */
    PENDING_FIRST_STEP = 'DOMAINS_MANAGEMENT.PENDING_FIRST_STEP',
    /**
     * @value The new login experience cannot be tested due to your configuration. Please contact your Lumapps contact for more information.
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_BLOCKED = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_BLOCKED',
    /**
     * @value The new login experience cannot be tested with Microsoft provider.
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_NO_MS = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_NO_MS',
    /**
     * @value The new login experience cannot be tested with the option “Just-in-Time provisioning” on your SAML configuration.
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_JIT = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_JIT',
    /**
     * @value You cannot test the new login experience due to your current SAML configuration
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_V1 = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_V1',
    /**
     * @value Platform URLs
     * @description Label of a side navigation menu that indicates the place to handle and update URLs of the whole platform
     */
    PLATFORM_URLS = 'DOMAINS_MANAGEMENT.PLATFORM_URLS',
    /**
     * @value After adding the record to your domain, the deployment can take a few hours.
     */
    RECORD_INFO = 'DOMAINS_MANAGEMENT.RECORD_INFO',
    /**
     * @value Record name
     */
    RECORD_NAME = 'DOMAINS_MANAGEMENT.RECORD_NAME',
    /**
     * @value Record type
     */
    RECORD_TYPE = 'DOMAINS_MANAGEMENT.RECORD_TYPE',
    /**
     * @value Record validity date: %VALIDITY_DATE%
     */
    RECORD_VALIDITY_DATE = 'DOMAINS_MANAGEMENT.RECORD_VALIDITY_DATE',
    /**
     * @value The provider generates a new value every 7 days until you've configured it
     */
    RECORD_VALIDITY_DATE_INFO = 'DOMAINS_MANAGEMENT.RECORD_VALIDITY_DATE_INFO',
    /**
     * @value Record value
     */
    RECORD_VALUE = 'DOMAINS_MANAGEMENT.RECORD_VALUE',
    /**
     * @value If you're using a root or an apex domain to reach LumApps (for example “mydomain.com” or “mydomain.co.uk”) and your DNS provider does not support a form of CNAME flattening, please reach out to LumApps support.
     */
    ROOT_APEX_DOMAIN = 'DOMAINS_MANAGEMENT.ROOT_APEX_DOMAIN',
    /**
     * @value DNS configurations and status
     */
    SUBTITLE = 'DOMAINS_MANAGEMENT.SUBTITLE',
    /**
     * @value support.lumapps.com
     */
    SUPPORT_MAIL = 'DOMAINS_MANAGEMENT.SUPPORT_MAIL',
    /**
     * @value If you have any questions, please contact LumApps support at %SUPPORT_LINK%.
     */
    SUPPORT_QUESTIONS = 'DOMAINS_MANAGEMENT.SUPPORT_QUESTIONS',
    /**
     * TODO: Split into two components
     */
    SUPPORT_QUESTIONS_V2 = 'DOMAINS_MANAGEMENT.SUPPORT_QUESTIONS_V2',
    /**
     * @value The Hive
     */
    THE_HIVE = 'DOMAINS_MANAGEMENT.THE_HIVE',
    /**
     * @value Domains management
     */
    TITLE = 'DOMAINS_MANAGEMENT.TITLE',
    /**
     * @value This page contains all the information regarding your vanity URL(s) migration as described in this communication on %THE_HIVE_LINK%.
     * @description Domains informations
     */
    UPDATE_DOMAIN_CERTIFICATES = 'DOMAINS_MANAGEMENT.UPDATE_DOMAIN_CERTIFICATES',
    UPDATE_DOMAIN_CERTIFICATES_V2 = 'DOMAINS_MANAGEMENT.UPDATE_DOMAIN_CERTIFICATES_V2',
    /**
     * @value Vanity URLs are custom URLs for your domains %LINK_MORE_INFO%
     */
    VANITY_URL_CUSTOM = 'DOMAINS_MANAGEMENT.VANITY_URL_CUSTOM',
    /**
     * @value Waiting for LumApps to deploy your custom certificate
     */
    WAITING_LUMAPPS_INFO = 'DOMAINS_MANAGEMENT.WAITING_LUMAPPS_INFO',
}
